<template>
  <div>
    <Slider />
    <div class="home-product">
      <div class="home-product-item" :style="`text-align: center;`" @click="readproduct($t('homeleft.buttonurl'))">
        <div v-if="isRouterAlive" class="product1" :style="`background: url(${leftproductimg})  no-repeat top center scroll;background-size: cover;height: 100%;`">
          <div class="item-title">{{ $t(`homeleft.title`) }}</div>
          <div class="item-subtitle">{{ $t("homeleft.subtitle") }}</div>
          <div class="item-more" >
            {{ $t("homeleft.button") }}
          </div>
        </div>
      </div>
      <div v-if="isRouterAlive" class="home-product-item" :style="`text-align: center;`"  @click="readproduct($t('homeright.buttonurl'))">
        <div class="product2" :style="`background: url(${rightproductimg})  no-repeat top center scroll;background-size: cover;height: 100%;`">
          <div class="item-title">{{ $t(`homeright.title`) }}</div>
          <div class="item-subtitle">{{ $t(`homeright.subtitle`) }}</div>
          <div class="item-more">{{ $t(`homeright.button`) }}</div>
        </div>
      </div>
    </div>
    <Footer class="w-100" />
  </div>
</template>

<script>
import Slider from "../components/slider";
import Footer from "../components/footer";
export default {
  name: "Bootstrap",
  components: {
    Slider,
    Footer,
  },
  data() {
    return {
      leftproduct: {},
      rightproduct: {},

       isRouterAlive:true
    };
  },
  computed: {
    leftproductimg() {
          return this.$store.state.leftproductimg;
    },
    rightproductimg() {
          return this.$store.state.rightproductimg;
    },
    },
  beforeMount() {
    this.getHomeProduct();
  },
  methods: { reload (){
       this.isRouterAlive = false
       this.$nextTick(function(){
          this.isRouterAlive = true
       })
    },
    getHomeProduct() {
      const _this = this;
      this.$store.dispatch("getHomeProduct").then(({zh,en}) => {
        _this.$i18n.mergeLocaleMessage("en", en);
        _this.$i18n.mergeLocaleMessage("zh", zh);

      let lang = _this.$i18n.locale
      _this.$i18n.locale = lang
      _this.reload()
      });
    },
    getValue(list, key) {
      return list.filter((x) => x.code == key)[0];
    },
    readproduct(url) {
      this.$router.push({ path: url });
    },
  },
  created(){
    this.$i18n.locale=localStorage.getItem('lang')||'zh'
  },
};
</script>
<style>
/* 产品系列 */
.home-product {
  padding: 10px 5px;
  position: relative;
  display: flex;
  flex-wrap: wrap;
}

.home-product .home-product-item {
  /* width: 50vw;
  height: 50vw;
  max-width: 500px;
  max-height: 500px; */
  width: 50%;
  min-height: 35vw;
  color: #ffffff;
  position: relative;
}

.home-product-item .product1 {
  margin: 0 5px;
  
}
.home-product-item .product2 {
  margin: 0 5px;
}
.item-title {
  font-size: 32px;
  padding-top: 11%;
}
.item-subtitle {
  font-size: 20px;
  padding-top: 3%;
  font-weight: 200;
}
.item-more {
  font-size: 16px;
  padding-top: 3%;
  font-weight: 100;
  cursor: pointer;
}
.item-more:hover {

  text-decoration: underline;
  color: #fff;
}
.indexslider-subtitle {
  margin-left: 115px;
  color: #fff;
  font-size: 24px;
}
.indexslider-title {
  margin-top: 10px;
  margin-left: 115px;
  color: #fff;
  font-size: 42px;
}
.indexslider-goal {
  margin-top: 20px;
  margin-left: 115px;
  color: #c00f31;
  font-size: 16px;
}
@media only screen and (max-width: 700px) {
  .item-title {
    font-size: 25px;
    padding-top: 11%;
  }
  .item-subtitle {
    font-size: 15px;
    padding-top: 6%;
    font-weight: 200;
  }
  .item-more {
    font-size: 12px;
    padding-top: 6%;
    font-weight: 100;
  }
}
@media only screen and (max-width: 500px) {
  .home-product {
    padding: 10px;
    position: relative;
    display: block;
  }

  .home-product .home-product-item {
    width: 100%;
    height: 80vw;
    color: #ffffff;
    position: relative;
  }

  .home-product-item .product1 {
    margin: 0 0 10px 0;
  }
  .home-product-item .product2 {
    margin: 10px 0 0 0;
  }
  .item-title {
    font-size: 20px;
    padding-top: 11%;
  }
  .item-subtitle {
    font-size: 10px;
    padding-top: 3%;
    font-weight: 200;
  }
  .item-more {
    font-size: 8px;
    padding-top: 3%;
    font-weight: 100;
  }
}

.indexslider-subtitle {
  margin-left: 100px;
  color: #fff;
  font-size: 24px;
}
.indexslider-title {
  margin-top: 10px;
  margin-left: 100px;
  color: #fff;
  font-size: 42px;
}
.indexslider-goal {
  margin-top: 20px;
  margin-left: 100px;
  color: #c00f31;
  font-size: 16px;
}
.indexslider-button {
  margin-left: 100px;
  margin-top: 40px;
}
.indexslider-button span {
  font-size: 16px;
  padding: 20px 50px;
  color: #888888;
  border: 1px solid #888888;
  cursor: pointer;
}
@media only screen and (max-width: 980px) {
  .indexslider-subtitle {
    margin-left: 50px;
    color: #fff;
    font-size: 24px;
  }
  .indexslider-title {
    margin-top: 0px;
    margin-left: 50px;
    color: #fff;
    font-size: 42px;
  }
  .indexslider-goal {
    margin-top: 20px;
    margin-left: 50px;
    color: #c00f31;
    font-size: 16px;
  }
  .indexslider-button {
    margin-left: 50px;
    margin-top: 40px;
  }
  .indexslider-button span {
    font-size: 16px;
    padding: 20px 50px;
    color: #888888;
    border: 2px solid #888888;
    cursor: pointer;
  }
}
@media only screen and (max-width: 700px) {
  .indexslider-subtitle {
    margin-top: 30px;
    margin-left: 40px;
    color: #fff;
    font-size: 20px;
  }
  .indexslider-title {
    margin-left: 40px;
    margin-top: 2px;
    color: #fff;
    font-size: 32px;
  }
  .indexslider-goal {
    margin-left: 40px;
    margin-top: 2px;
    color: #c00f31;
    font-size: 12px;
  }
  .indexslider-button {
    margin-left: 40px;
    margin-top: 10px;
  }
  .indexslider-button span {
    font-size: 16px;
    padding: 10px 30px;
    color: #888888;
    border: 2px solid #888888;
    cursor: pointer;
  }
}

.indexslider-button span:hover {
  background-color: #888888;
  color: #fff;
  cursor: pointer;
}
@media only screen and (max-width: 500px) {
  .indexslider-subtitle {
    margin-top: 50px;
    margin-left: 50px;
    color: #fff;
    font-size: 15px;
  }
  .indexslider-title {
    margin-left: 50px;
    margin-top: 0px;
    color: #fff;
    font-size: 25px;
  }
  .indexslider-goal {
    margin-left: 50px;
    margin-top: 10px;
    color: #c00f31;
    font-size: 8px; 
  }
  .indexslider-button {
    margin-left: 50px;
    margin-top: 30px;
  }
  .indexslider-button span {
    font-size: 8px;
    padding: 4px 25px;
    color: #888888;
    font-weight: 200;
    border: 1px solid #888888;
    cursor: pointer;
  }
}

.indexslider-button span:hover {
  background-color: #888888;
  color: #fff;
  cursor: pointer;
}
</style>
